import {BaseContainerModel} from '../../base-container.model';
import {bl_crm_address_book_member_link_RowClass} from '../../../dbschema/bl_crm_address_book_member_link.model'

export class CrmAddressBookMemberLinkContainerModel extends BaseContainerModel {
    bl_crm_address_book_member_link: bl_crm_address_book_member_link_RowClass = new bl_crm_address_book_member_link_RowClass()
  }
